import { useState } from "react";
import { FileText, Loader2, Mail } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { today, yearStart } from "@/lib/format";
import { DateRange } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function StatementDialog({ client, onClose }) {
  const { t } = useLang();
  const [range, setRange] = useState({ start: yearStart(), end: today() });
  const [busy, setBusy] = useState("");
  const download = async () => {
    setBusy("pdf");
    try {
      const r = await api.get(`/clients/${client.id}/statement.pdf`, { params: range, responseType: "blob" });
      const u = URL.createObjectURL(r.data);
      Object.assign(document.createElement("a"), { href: u, download: `statement-${client.name}-${range.start}-${range.end}.pdf` }).click();
      URL.revokeObjectURL(u);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy("");
  };
  const send = async () => {
    setBusy("mail");
    try { await api.post(`/clients/${client.id}/statement/send`, null, { params: range }); toast.success(t("statementSent")); }
    catch (e) { const code = e?.response?.data?.detail?.code; toast.error(code === "client_no_email" ? t("clientNoEmail") : code === "email_failed" ? t("emailFailed") : errMsg(e)); }
    setBusy("");
  };
  return (
    <Dialog open={!!client} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="statement-dialog">
        <DialogHeader><DialogTitle className="font-display">{t("statement")} — {client?.name}</DialogTitle><DialogDescription>{t("statementText")}</DialogDescription></DialogHeader>
        <DateRange testid="statement-range" start={range.start} end={range.end} onChange={(start, end) => setRange({ start, end })} />
        <div className="flex flex-col gap-2 sm:flex-row">
          <Button data-testid="statement-pdf-btn" disabled={!!busy} onClick={download} className="flex-1 bg-[#0B1220] text-white hover:bg-slate-800">{busy === "pdf" ? <Loader2 className="me-1 h-4 w-4 animate-spin" /> : <FileText className="me-1 h-4 w-4" />}{t("downloadPdf")}</Button>
          <Button data-testid="statement-send-btn" disabled={!!busy || !client?.email} onClick={send} variant="outline" className="flex-1">{busy === "mail" ? <Loader2 className="me-1 h-4 w-4 animate-spin" /> : <Mail className="me-1 h-4 w-4" />}{t("sendToClient")}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
